//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            globalAmenityListUrl: '/api/amenities',
            baseUrl: "/prototype/properties/amenities/",
            headers: ["Amenity Name", "Description", "Value"],
            editItem: null,
            insertItem: false,
            globalAmenities: [],
            amenities: [],
            newPropertyAmenity: {
                amenity: {
                    id: null,
                    name: '',
                    description: ''
                },
                value: 0
            },
            money: {
                decimal: ".",
                thousands: ",",
                prefix: "$",
                suffix: "",
                precision: 2,
                masked: false
            }
        };
    },


    methods: {
        addNew: function addNew() {
            if (this.insertItem) {
                this.$snotify.info("Please finish your current addition first");
            } else {
                this.insertItem = true;
                this.newPropertyAmenity = {
                    id: null,
                    amenity: {
                        id: null,
                        name: '',
                        description: ''
                    },
                    value: 0
                };
            }
        },
        createAmenity: function createAmenity() {
            var _this = this;

            var payload = {
                amenities_id: this.newPropertyAmenity.amenity.id,
                value: this.newPropertyAmenity.value
            };

            axios.post(this.baseUrl, payload).then(function (response) {
                if (response instanceof Error) {
                    return Promise.reject();
                }
                _this.insertItem = false;
                _this.amenities.unshift(response.data);
            }).catch(function (_) {
                _this.$snotify.warning('Failed to create a new property amenity');
            });
        },
        removeAmenity: function removeAmenity(idx) {
            var _this2 = this;

            var propAmenityToDelete = this.amenities[idx];

            axios.delete("" + this.baseUrl + propAmenityToDelete.id).then(function (response) {
                if (response instanceof Error) {
                    return Promise.reject();
                }
                _this2.$snotify.success(propAmenityToDelete.amenity_name + " was deleted successfully");
                _this2.removeItem(idx);
            }).catch(function (_) {
                _this2.$snotify.warning("Unable to delete " + propAmenityToDelete.amenity_name);
            });
        },
        saveAmenity: function saveAmenity(idx) {
            var _this3 = this;

            var amenityToSave = this.amenities[idx];

            axios.patch("" + this.baseUrl + amenityToSave.id, { value: amenityToSave.value }).then(function (response) {
                if (response instanceof Error) {
                    return Promise.reject();
                }
                _this3.editItem = null;
                _this3.$snotify.success(amenityToSave.amenity_name + " was updated.");
            }).catch(function (_) {
                _this3.$snotify.warning("Failed to update " + amenityToSave.amenity_name + ".");
            });
        },
        setDefaultAmenityValue: function setDefaultAmenityValue(newSelection) {

            if (newSelection) {
                this.newPropertyAmenity.amenity = newSelection;
                if (newSelection.value) {
                    this.newPropertyAmenity.value = newSelection.value;
                }
            }
        },
        removeItem: function removeItem(idx) {
            this.amenities.splice(idx, 1);
        },
        close: function close() {
            Event.$emit('close-full-modal');
        },
        load: function load() {
            var _this4 = this;

            this.$children[0].$data.showModal = true;

            axios.get(this.baseUrl).then(function (response) {
                _this4.amenities = response.data;
            });

            axios.get(this.globalAmenityListUrl).then(function (response) {
                _this4.globalAmenities = response.data;
            });
        }
    },

    created: function created() {
        Event.$on('property-settings-amenities', this.load);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('property-settings-amenities');
    },


    computed: {
        filteredAmenities: function filteredAmenities() {
            var _this5 = this;

            return this.globalAmenities.filter(function (globalAmenity) {
                return !_this5.amenities.find(function (propAmenity) {
                    return propAmenity.amenities_id === globalAmenity.id;
                });
            });
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/settings/PropertySettingsAmenities.vue
// module id = Tm/f
// module chunks = 0 1